// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: media.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";

export const protobufPackage = "com.tick2trade.api.media";

export enum MediaPurpose {
  PURPOSE_UNKNOWN = 0,
  FEEDBACK = 1,
  PROFILE = 2,
  UNRECOGNIZED = -1,
}

export function mediaPurposeFromJSON(object: any): MediaPurpose {
  switch (object) {
    case 0:
    case "PURPOSE_UNKNOWN":
      return MediaPurpose.PURPOSE_UNKNOWN;
    case 1:
    case "FEEDBACK":
      return MediaPurpose.FEEDBACK;
    case 2:
    case "PROFILE":
      return MediaPurpose.PROFILE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MediaPurpose.UNRECOGNIZED;
  }
}

export function mediaPurposeToJSON(object: MediaPurpose): string {
  switch (object) {
    case MediaPurpose.PURPOSE_UNKNOWN:
      return "PURPOSE_UNKNOWN";
    case MediaPurpose.FEEDBACK:
      return "FEEDBACK";
    case MediaPurpose.PROFILE:
      return "PROFILE";
    case MediaPurpose.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetMediaUploadUrlRequest {
  fileName: string;
  contentType: string;
  purpose: MediaPurpose;
}

export interface GetMediaUploadUrlResponse {
  uploadUrl: string;
  s3Key: string;
}

function createBaseGetMediaUploadUrlRequest(): GetMediaUploadUrlRequest {
  return { fileName: "", contentType: "", purpose: 0 };
}

export const GetMediaUploadUrlRequest = {
  encode(message: GetMediaUploadUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    if (message.contentType !== "") {
      writer.uint32(18).string(message.contentType);
    }
    if (message.purpose !== 0) {
      writer.uint32(24).int32(message.purpose);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetMediaUploadUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaUploadUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.contentType = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.purpose = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaUploadUrlRequest {
    return {
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      contentType: isSet(object.contentType) ? globalThis.String(object.contentType) : "",
      purpose: isSet(object.purpose) ? mediaPurposeFromJSON(object.purpose) : 0,
    };
  },

  toJSON(message: GetMediaUploadUrlRequest): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    if (message.purpose !== 0) {
      obj.purpose = mediaPurposeToJSON(message.purpose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaUploadUrlRequest>, I>>(base?: I): GetMediaUploadUrlRequest {
    return GetMediaUploadUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaUploadUrlRequest>, I>>(object: I): GetMediaUploadUrlRequest {
    const message = createBaseGetMediaUploadUrlRequest();
    message.fileName = object.fileName ?? "";
    message.contentType = object.contentType ?? "";
    message.purpose = object.purpose ?? 0;
    return message;
  },
};

function createBaseGetMediaUploadUrlResponse(): GetMediaUploadUrlResponse {
  return { uploadUrl: "", s3Key: "" };
}

export const GetMediaUploadUrlResponse = {
  encode(message: GetMediaUploadUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uploadUrl !== "") {
      writer.uint32(10).string(message.uploadUrl);
    }
    if (message.s3Key !== "") {
      writer.uint32(18).string(message.s3Key);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetMediaUploadUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMediaUploadUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uploadUrl = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.s3Key = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMediaUploadUrlResponse {
    return {
      uploadUrl: isSet(object.uploadUrl) ? globalThis.String(object.uploadUrl) : "",
      s3Key: isSet(object.s3Key) ? globalThis.String(object.s3Key) : "",
    };
  },

  toJSON(message: GetMediaUploadUrlResponse): unknown {
    const obj: any = {};
    if (message.uploadUrl !== "") {
      obj.uploadUrl = message.uploadUrl;
    }
    if (message.s3Key !== "") {
      obj.s3Key = message.s3Key;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMediaUploadUrlResponse>, I>>(base?: I): GetMediaUploadUrlResponse {
    return GetMediaUploadUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMediaUploadUrlResponse>, I>>(object: I): GetMediaUploadUrlResponse {
    const message = createBaseGetMediaUploadUrlResponse();
    message.uploadUrl = object.uploadUrl ?? "";
    message.s3Key = object.s3Key ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
